const CustomSpinner = ({spinnerColour}: any) => {
    return (
      <div className={`tw-animate-spin tw-border-4 tw-border-t-4 ${spinnerColour} tw-border-gray-200 tw-rounded-full tw-w-6 tw-h-6`}></div>
    );
  };
  
  export default CustomSpinner;
  